<div class="custom-select-container" #customSelect>
    <span class="por-doctor">por:</span>
    <div class="selected-doctor" (click)="toggleDropdown($event)">
      <span>{{ selectedDoctor?.nombre || 'Seleccione Doctor' }}</span>
      <i class="arrow" [ngClass]="{ 'open': isDropdownOpen }"></i>
    </div>
    <ul class="doctor-dropdown" *ngIf="isDropdownOpen">
      <li *ngFor="let doctor of measurementManager"
          (click)="selectDoctor(doctor)">
        {{ doctor.nombre }}
      </li>
    </ul>
  </div>